import React, { useRef, useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import { apiUrl } from "../services/api";
import "../App.css";

const SVGComponent = ({ conducteur }) => {
  const arrayBufferToBase64 = (buffer) => {
    let binary = "";
    const bytes = new Uint8Array(buffer);
    const len = bytes.byteLength;
    for (let i = 0; i < len; i++) {
      binary += String.fromCharCode(bytes[i]);
    }
    return btoa(binary);
  };

  const printContainerStyle = {
    display: "flex",
    flexDirection: "column",
    pageBreakAfter: "always", 
  };

  const pageStyle = {
    height: "100vh", 
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    padding: "20px",
    pageBreakAfter: "always", 
  };

  const halfPageStyle = {
    height: "50%", 
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  };

  const imageStyle = {
    maxWidth: "100%",
    maxHeight: "100%",
    objectFit: "contain", 
    border: "1px solid #ccc",
    padding: "10px",
    backgroundColor: "white",
  };

  return (
    <div style={printContainerStyle}>
      {/* First Page: Front of ID Card and Driving License */}
      <div style={pageStyle}>
        <div style={halfPageStyle}>
          {conducteur.scan_cin_front && (
            <img
              src={`data:image/jpeg;base64,${arrayBufferToBase64(
                conducteur.scan_cin_front.data
              )}`}
              alt="CIN Front"
              style={imageStyle}
            />
          )}
        </div>
        <div style={halfPageStyle}>
          {conducteur.scan_permis_front && (
            <img
              src={`data:image/jpeg;base64,${arrayBufferToBase64(
                conducteur.scan_permis_front.data
              )}`}
              alt="Driving License Front"
              style={imageStyle}
            />
          )}
        </div>
      </div>

      {/* Second Page: Back of ID Card and Driving License */}
      <div style={pageStyle}>
        <div style={halfPageStyle}>
          {conducteur.scan_cin_back && (
            <img
              src={`data:image/jpeg;base64,${arrayBufferToBase64(
                conducteur.scan_cin_back.data
              )}`}
              alt="CIN Back"
              style={imageStyle}
            />
          )}
        </div>
        <div style={halfPageStyle}>
          {conducteur.scan_permis_back && (
            <img
              src={`data:image/jpeg;base64,${arrayBufferToBase64(
                conducteur.scan_permis_back.data
              )}`}
              alt="Driving License Back"
              style={imageStyle}
            />
          )}
        </div>
      </div>
    </div>
  );
};

const PrintCinPermis = () => {
  const [conducteur, setConducteur] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const { id } = useParams();
  const printRef = useRef();

  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true);
      try {
        const conducteurRes = await axios.get(
          `${apiUrl}/conducteur/cin-permis/${id}`
        );
        setConducteur(conducteurRes.data[0]);

        // console.log(conducteur);
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }

  return (
    <div>
      <button onClick={handlePrint} className="print-button no-print">
        Imprimer
      </button>
      <div ref={printRef} className="print-container">
        <SVGComponent conducteur={conducteur} />
      </div>
    </div>
  );
};

export default PrintCinPermis;
